import styled from 'styled-components'
import { Button, Table } from 'antd'

export const StyledTable = styled(Table)`
  .ant-table-title {
    padding: 0;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StyledButton = styled(Button)`
  &:first-child {
    margin-bottom: 10px;
  }
`

export const Buttons = styled.div`
  display: flex;
  & > button:first-child {
    margin-right: 10px;
  }
`
